import request from '../http/index'

// 列表
export async function ActivityRecordList(params = {}) {
  const res = await request.post('/api/ba/ActivityRecord/List', params);
  return res.data;
}

// 明细
export async function ActivityRecordDetail(params = {}) {
  const res = await request.post('/api/ba/ActivityRecord/Detail', params);
  return res.data;
}

// 查看
export async function ActivityRecordInfo(params = {}) {
  const res = await request.post('/api/ba/ActivityRecord/Info', params);
  return res.data;
}

// 导出
export async function ActivityRecordExport(params = {}) {
  const res = await request.post('/api/ba/ActivityRecord/Export', params, {
    responseType: 'blob'
  });
  return res.data;
}

// 修改
export async function ActivityRecordEdit(data = {}) {
  const res = await request.post('/api/ba/ActivityRecord/Edit', data);
  return res.data;
}

// 删除
export async function ActivityRecordDelete(data = {}) {
  const res = await request.post('/api/ba/ActivityRecord/Delete', data);
  return res.data;
}

// 举办活动 (新增)
export async function ActivityRecordAdd(data = {}) {
  const res = await request.post('/api/ba/ActivityRecord/Add', data);
  return res.data;
}

// 完成活动
export async function ActivityRecordVerify(data = {}) {
  const res = await request.post('/api/ba/ActivityRecord/Verify', data);
  return res.data;
}
